<template>
  <div class="p-[12px] flex items-center justify-start gap-[8px] text-left">
    {{ value }}
  </div>
</template>

<script>
export default {
  name: 'GeneralCell',
  props: {
    value: {
      type: String,
      required: false,
      default: '-',
    },
  },
}
</script>
